// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/contabil/services/acessoContadorService.ts
//  Lado do cliente do Portal do Contador: quem tem acesso, convidar e revogar.
//  Ver AcessoContadorController (/api/contabil/plataforma-contador/acesso).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/contabil/plataforma-contador/acesso';

export interface AcessoContador {
  id: number;
  empresaId?: number | null;
  empresa?: string | null;
  escritorio: string;
  escritorioCnpj?: string | null;
  ativo: boolean;
  autorizadoPor?: string | null;
  dtAutorizacao: string;
  revogadoPor?: string | null;
  dtRevogacao?: string | null;
  usuarios: { nome: string; email: string; senhaDefinida: boolean; dtUltimoLogin?: string | null }[];
}

export interface AcessosContador {
  empresas: { id: number; razaoSocial?: string | null; cnpjCpf: string }[];
  acessos: AcessoContador[];
}

export interface ConvidarContadorRequest {
  email: string;
  nome?: string;
  cnpjEscritorio?: string;
  razaoEscritorio?: string;
  empresaIds: number[];
}

export interface ConvidarContadorResultado {
  usuarioNovo: boolean;
  emailEnviado: boolean;
  linkConvite?: string | null;
  mensagem: string;
}

export const acessoContadorService = {
  async listar() {
    const r = await apiClient.get<AcessosContador>(BASE);
    return r.data;
  },
  async convidar(req: ConvidarContadorRequest) {
    const r = await apiClient.post<ConvidarContadorResultado>(BASE, req);
    return r.data;
  },
  revogar: (id: number) => apiClient.delete(`${BASE}/${id}`),
};
